<template>
  <div class="field">
    <label
      class="label"
      :for="id"
    >
      {{ label }}
    </label>
    <div
      class="control"
      :class="controlClass"
    >
      <input
        :id="id"
        class="input"
        :name="name"
        :placeholder="placeholder"
        :value="value"
        :disabled="disabled"
        :required="required"
        :pattern="pattern ? pattern : null"
        :type="type"
        :step="step"
        :min="min"
        :max="max"
        :minlength="minlength"
        :maxlength="maxlength"
        @input="$emit('input', $event)"
        @change="$emit('change', $event)"
        @focus="$emit('focus', $event)"
        @blur="$emit('blur', $event)"
      >
      <b-icon
        v-if="leftIcon"
        class="is-small is-left"
        :icon="leftIcon"
      />
      <b-icon
        v-if="rightIcon"
        class="is-small is-right"
        :icon="rightIcon"
      />
      <p
        v-if="errorMessage"
        class="help is-danger"
      >
        {{ errorMessage }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppInputField',
  props: {
    id: {
      type: [String, Number],
      default: '',
    },
    name: {
      type: [String, Number],
      default: '',
    },
    label: {
      type: [String, Number],
      default: '',
    },
    placeholder: {
      type: [String, Number],
      default: '',
    },
    pattern: {
      type: String,
      default: '',
    },
    leftIcon: {
      type: String,
      default: '',
    },
    rightIcon: {
      type: String,
      default: '',
    },
    errorMessage: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    step: {
      type: String,
      default: null,
      required: false,
    },
    min: {
      type: String,
      default: null,
      required: false,
    },
    max: {
      type: String,
      default: null,
      required: false,
    },
    minlength: {
      type: Number,
      default: null,
      required: false,
    },
    maxlength: {
      type: Number,
      default: null,
      required: false,
    },
    value: {
      type: [String, Number],
      default: '',
    },
    disabled: {
      type: Boolean,
    },
    isLoading: {
      type: Boolean,
    },
    readonly: {
      type: Boolean,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    controlClass() {
      return {
        'has-icons-left': this.leftIcon,
        'has-icons-right': this.rightIcon,
        'is-loading': this.isLoading,
      };
    },
  },
};
</script>
